// extracted by mini-css-extract-plugin
export default {"footer":"Footer-module__footer--nskFT","footer__inner":"Footer-module__footer__inner--IxqGI"};